/**
 * We have multiple sources of pilots from PageContext: FeaturePilotFlag and Permissions attributes
 * @param {Object} pageContext The server's page context object
 * @returns {Object} merging the pilots source
 */
const pilotsObject = pageContext => ({ ...pageContext.FeaturePilotFlag, ...pageContext.Permissions, ...(pageContext.Permissions || {}).dynamic });

/**
 * Returns true if the pilotFlag exists in pageContext, false otherwise
 * @param {Object} pageContext The server's page context object
 * @param {String} pilotFlag Indicate the pilot's string name
 * @returns {Boolean} true if the pilotFlag exists in pageContext, false otherwise
 */
export const isPilotEnabled = (pageContext, pilotFlag) => (pageContext && pilotsObject(pageContext)[pilotFlag] === true) || false;

